import { useStore } from '../store/store'
import { getPrimaryDark } from '../constants/constants'

export const hexToRgba = (hex, alpha) => {
  const value = hex.replace('#', '')
  const r = parseInt(value.substring(0, 2), 16)
  const g = parseInt(value.substring(2, 4), 16)
  const b = parseInt(value.substring(4, 6), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

// Couleur d'accent courante (violet en mode template, navy en mode
// proposal — cf. getPrimaryDark), lue hors cycle de rendu React pour les
// fonctions de style utilitaires qui ne sont pas des composants (donc sans
// accès à useStore en tant que hook). Pas réactif à lui seul, mais toujours
// appelé depuis le rendu d'un composant qui, lui, re-render au changement de
// document (template <-> proposal implique une navigation, donc un re-render).
export const getAccentColor = () => getPrimaryDark(useStore.getState().currentDocument?.type === 'template')
